<template>
    <el-dialog
        :visible.sync="visible"
        :before-close="() => this.onClose(false)"
        :show-close="false"
        custom-class="detalleProducto"
        append-to-body>

        <span slot="title" > 
            <el-row class="headerDialog">
                <el-col :span="24">{{$t('PRODUCTO_detalle')}}</el-col>
            </el-row>
        </span>
    <!-- Cuerpo -->
    <div>
        <el-row>
            <el-col :span="24" class="blackLabel">{{producto.Nombre}}</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel">{{$t('GENERAL_descripcion')}}:</el-col>
            <el-col :span="16">{{producto.Descripcion}}</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel">{{$t('PRODUCTO_precio_unitario')}}:</el-col>
            <el-col :span="16">${{producto.Precio}}</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel">{{$t('PEDIDO_iva')}}:</el-col>
            <el-col :span="16">{{producto.IVA}}%</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="greyLabel">{{$t('PEDIDO_bonificacion')}}:</el-col>
            <el-col :span="16">{{producto.BonificacionPorcentaje}}%</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="greyLabel">{{$t('PEDIDO_unidad_medida')}}:</el-col>
            <el-col :span="16">{{producto.UnidadMedida}}</el-col>
        </el-row>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="btnConfirm" @click="cancelar">{{ cancelBtn || $t('GENERAL_cancelBtn') }}</el-button>
    </span>

    </el-dialog>
</template>

<script>
  export default {
    name: 'DetalleProductoDialog',
    props: {
      visible: Boolean,
      cancelBtn: String,
      confirmBtn: String,
      onClose: Function,
      producto: Object,
    },
    data(){
      return {
        innerVisible: false,
      }
    },
    methods: {
      cancelar(){
          this.onClose(false);
      },
    }
  }
  </script>
  
  <style>
    .detalleProducto .el-dialog__header {
        background-color: var(--main-color);
        color: #ffffff;
        font-size: 1.5em;
        font-weight: bold;
        padding: 10px 0 10px 20px;
    }
  
  </style>